import React, { useEffect, useState } from 'react';
import { Heart, Eye, Loader2, RefreshCw } from 'lucide-react';
import { adminEngage } from '../../services/cms';

const fmt = (n) => (n === null || n === undefined ? '—' : new Intl.NumberFormat('fr-FR').format(n));

const EngagePanel = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  const load = () => {
    setLoading(true);
    adminEngage().then(setData).catch(() => setData({ items: [], totals: {} })).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const items = (data?.items || []).filter((i) => (i.titre || '').toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="engage-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
          <h2 className="font-display font-700 text-2xl">Engagement</h2>
          <p className="text-sm text-muted-foreground font-600">Cumul lecture seule : WordPress (importé) + Engage (local). Aucune écriture WordPress.</p>
        </div>
        <button onClick={load} data-testid="engage-refresh" className="flex items-center gap-2 px-4 py-2 rounded-full bg-muted font-700 text-sm hover:bg-primary hover:text-white transition-colors">
          <RefreshCw className="w-4 h-4" /> Actualiser
        </button>
      </div>

      {data?.totals && (
        <div className="flex flex-wrap gap-3 mb-5">
          <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary/10 text-primary font-700 text-sm" data-testid="engage-total-likes"><Heart className="w-4 h-4" /> {fmt(data.totals.engage_likes)} likes Engage</span>
          <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-secondary/15 text-secondary-foreground font-700 text-sm" data-testid="engage-total-views"><Eye className="w-4 h-4" /> {fmt(data.totals.engage_views)} vues Engage</span>
        </div>
      )}

      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Rechercher un webtoon…"
        data-testid="engage-search"
        className="w-full sm:max-w-sm mb-4 px-4 py-2.5 rounded-xl border border-border bg-background font-600 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
      />

      {loading ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-7 h-7 animate-spin text-primary" /></div>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-border">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-muted text-left font-800 text-xs uppercase text-muted-foreground">
                <th className="px-4 py-3">Webtoon</th>
                <th className="px-4 py-3 text-right">Likes WP</th>
                <th className="px-4 py-3 text-right">Vues WP</th>
                <th className="px-4 py-3 text-right">Likes Engage</th>
                <th className="px-4 py-3 text-right">Vues Engage</th>
                <th className="px-4 py-3 text-right">Total likes</th>
                <th className="px-4 py-3 text-right">Total vues</th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.source_id} className="border-t border-border hover:bg-muted/40" data-testid={`engage-row-${i.source_id}`}>
                  <td className="px-4 py-3 font-700">
                    {i.titre}
                    <span className="block text-xs text-muted-foreground font-500">#{i.source_id}</span>
                  </td>
                  <td className="px-4 py-3 text-right tabular-nums">{fmt(i.wp_likes)}</td>
                  <td className="px-4 py-3 text-right tabular-nums">{fmt(i.wp_views)}</td>
                  <td className="px-4 py-3 text-right tabular-nums font-700 text-primary">{fmt(i.engage_likes)}</td>
                  <td className="px-4 py-3 text-right tabular-nums font-700 text-primary">{fmt(i.engage_views)}</td>
                  <td className="px-4 py-3 text-right tabular-nums font-800">{fmt(i.total_likes)}</td>
                  <td className="px-4 py-3 text-right tabular-nums font-800">{fmt(i.total_views)}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={7} className="px-4 py-10 text-center text-muted-foreground font-600">Aucun webtoon.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EngagePanel;
